import { useEffect } from 'react';

/**
 * PerformanceMonitor Component
 * Monitors and reports web vitals and performance metrics
 */
const PerformanceMonitor = () => {
  useEffect(() => {
    // Only run in production
    if (process.env.NODE_ENV !== 'production') return;

    // Report Web Vitals
    const reportWebVitals = (metric) => {
      // Send to analytics (console for now, could be Google Analytics, etc.)
      console.log('[Web Vitals]', metric);
      
      // You can send this to your analytics service
      // Example: analytics.track('web_vital', metric);
    };

    // Core Web Vitals (web-vitals v5+ observer API)
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(reportWebVitals);
      onINP(reportWebVitals);
      onFCP(reportWebVitals);
      onLCP(reportWebVitals);
      onTTFB(reportWebVitals);
    }).catch(() => {});

    // Performance Observer for Long Tasks
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.duration > 50) {
            console.warn('[Long Task]', {
              duration: entry.duration,
              startTime: entry.startTime,
            });
          }
        }
      });

      try {
        observer.observe({ entryTypes: ['longtask'] });
      } catch (e) {
        // Browser doesn't support longtask
      }

      return () => observer.disconnect();
    }
  }, []);

  return null;
};

export default PerformanceMonitor;
